import type { ReactNode } from 'react';
import { Tooltip } from '@odo/shared-ui';
import { CategoryChip } from './CategoryChip';

// One chip shown, not two - a second would truncate to a couple characters.
const MAX_PILLS_SHOWN = 1;
const PILL_LABEL_MAX_WIDTH = '84px';

function OverflowPill({ names }: { names: string[] }) {
    if (names.length === 0) return null;
    return (
        <Tooltip content={names.join(', ')}>
            <span className="inline-flex items-center rounded-full bg-gray-50 border border-gray-200 text-gray-500 font-semibold text-[11px] h-6 px-2 whitespace-nowrap shrink-0">
                +{names.length}
            </span>
        </Tooltip>
    );
}

interface CategoryPillsCappedProps {
    categories: string[];
    emptyFallback?: ReactNode;
}

// Capped at MAX_PILLS_SHOWN so a thread with several categories doesn't
// blow out the row. Shared by the table and recent-communications list.
export function CategoryPillsCapped({
    categories,
    emptyFallback = null
}: CategoryPillsCappedProps) {
    if (categories.length === 0) return <>{emptyFallback}</>;
    const shown = categories.slice(0, MAX_PILLS_SHOWN);
    const overflow = categories.slice(MAX_PILLS_SHOWN);
    return (
        <div className="flex items-center gap-1">
            {shown.map((id) => (
                <CategoryChip key={id} id={id} maxLabelWidth={PILL_LABEL_MAX_WIDTH} />
            ))}
            <OverflowPill names={overflow} />
        </div>
    );
}
